import { useState, useEffect } from 'react';

import type {
  CreateFavoriteRequest,
  DeleteFavoriteRequest,
  GetFavoriteRequest,
} from '../output/apis/FavoritesApi';
import type { Stock } from '../output/models';

import { config } from '../config';
import { FavoritesApi } from '../output/apis/FavoritesApi';

import { token } from '../utils';

interface Response {
  favorite: boolean;
  createFavorite: () => void;
  deleteFavorite: () => void;
}

export const useFavorite = (stock: Stock | undefined, initialState: boolean): Response => {
  const [favorite, setFavorite] = useState<boolean>(initialState);

  const createFavorite = () => {
    if (!stock) {
      return;
    }

    const req: CreateFavoriteRequest = { xCSRFToken: token(), stockId: String(stock.id) };

    new FavoritesApi(config).createFavorite(req).catch((e) => {
      setFavorite(false);
      console.log(e);
    });

    setFavorite(true);
  };

  const deleteFavorite = () => {
    if (!stock) {
      return;
    }

    const req: DeleteFavoriteRequest = { xCSRFToken: token(), stockId: String(stock.id) };

    new FavoritesApi(config).deleteFavorite(req).catch((e) => {
      setFavorite(true);
      console.log(e);
    });

    setFavorite(false);
  };

  useEffect(() => {
    if (!stock || initialState) {
      return;
    }

    const req: GetFavoriteRequest = { stockId: String(stock.id) };

    new FavoritesApi(config)
      .getFavorite(req)
      .then((res) => {
        if (res.favorite) {
          setFavorite(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [stock, initialState]);

  return { favorite, createFavorite, deleteFavorite };
};
